import axios from 'axios';
import apiConfig from '../api.config';
import { gzipSync, strToU8 } from 'fflate';
const CancelToken = axios.CancelToken;
let cancel;

export default function generatePreviewPdf(hotelId, htmlText, lang) {
  const {
    host,
    URIs: { generatePreviewPdf },
  } = apiConfig;

  const uri = `${host}${generatePreviewPdf}`;

  if (cancel) cancel();

  const formData = new FormData();

  formData.append('hotelId', hotelId);
  if (lang) formData.append('lang', lang);

  if (htmlText) {
    const htmlBytes = strToU8(htmlText);
    const compressed = gzipSync(htmlBytes);
    const compressedFile = new File([compressed], 'pdfPreview.html.gz', {
      type: 'application/gzip',
    });

    formData.append('htmlText', compressedFile);
  }

  return axios
    .post(uri, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      responseType: 'arraybuffer',
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    })
    .then(res => {
      const blob = new Blob([res.data], { type: 'application/pdf' });
      return URL.createObjectURL(blob);
    });
}
